module.exports = __webpack_public_path__ + "img/image79.cb576814.jpg";